export const setUsers = (state, payload) => {

  if( payload.hide_details ) {

    //var newUsers = [];

    for( var p in payload.users ) {

      var cipherEmail = payload.users[p].email;
          cipherEmail = atob(cipherEmail);
          cipherEmail = atob(cipherEmail);
          cipherEmail = atob(cipherEmail);
          cipherEmail = atob(cipherEmail);

      var objCipher = cipherEmail.split('|');

      payload.users[p].email = objCipher[1];

      //newUsers.push({ id: payload.users[p].id,email: objCipher[1],fullname: payload.users[p].fullname,roleName: payload.users[p].roleName,roleNewId: payload.users[p].roleNewId });

    }

    //payload.users = newUsers;

  }

	switch (payload.context) {
		case 1:
			state.repUsers = payload.users;
			break;
		case 2:
			var customerUsers = [];
			/*for (var k in payload.users) {
				var didBranch = false;
				for (var b in payload.branchUsers) {
					if (payload.users[k].attr.id == payload.branchUsers[b].id) {
						didBranch = true;
						for (var x in payload.branchUsers[b].branch ) {
							payload.branchUsers[b].branch[x].company = parseInt(payload.branchUsers[b].branch[x].company);
						}
						customerUsers.push({ id: payload.users[k].attr.id, attr: payload.users[k].attr, branch: payload.branchUsers[b].branch });
					}
				}
				if( didBranch == false ) {
					customerUsers.push({ attr: payload.users[k].attr, branch: [] });
				}
			}*/

			state.customerUsers = payload.branchUsers;
			// state.customerUsers = customerUsers;
			break;
		case 3:
			for (var u in payload.users) {
				payload.users[u].company = parseInt(payload.users[u].company);
			}
			state.specificUsers = payload.users;
			break;
		case 4:
			/*for( var u in payload.users ) {
				payload.users[u].company = parseInt(payload.users[u].company);
			}*/
			state.publicUsers = payload.users;
			break;
		case 6:
			state.vendorUsers = payload.users;
			break;
    case 0:
      state.repUsers = payload.users;
      break;
	}
}

export const setObjUserSettings = (state, payload, rootState) => {
	var objSettings = {
		manufacturerAlias: payload.manu_user_alias,
		manufacturerColor: payload.manu_user_clr,
        customerAlias: payload.customer_user_alias,
        customerColor: payload.customer_user_clr,
        specificAlias: payload.specifier_user_alias,
        specificColor: payload.specifier_user_clr,
        publicAlias: payload.public_user_alias,
        publicColor: payload.public_user_clr
	};
	state.objUserSettings = objSettings;
}

export const fncEmptyUserSettings = (state, payload) => {
	state.objUserSettings = '';
}

export const fncEmptyUserNotifications = (state, payload) => {
	state.objUserNotifications = [];
}

export const setUserNotifications = (state, payload) => {

	var newUsers = [];

	for( var u in payload.users ) {
		if( payload.users[u].description == 'Internal Notifications' ) {
			payload.users[u].description = 'Notifications';
			newUsers.push( payload.users[u] );
		}
	}

	for( var u in payload.users ) {
		if( payload.users[u].description != 'Internal Notifications' ) {
			newUsers.push( payload.users[u] );
		}
	}

	payload.users = newUsers;

	for (var k in payload.users) {
		payload.users[k].get_email = parseInt(payload.users[k].get_email);
		payload.users[k].get_sms = parseInt(payload.users[k].get_sms);
		payload.users[k].get_push = parseInt(payload.users[k].get_push);
	}

	state.objUserNotifications = payload;
}

export const fncUserPricelists = (state, payload) => {
	var pricelistsMain = [];
	var pricelistsSorted = [];
	var pricelistAdded = [];
	for (var k in payload.userPricelists ) {
		pricelistsSorted[parseInt(payload.userPricelists[k].pricelist_order)-1] = payload.userPricelists[k]
	}
	for (var p in pricelistsSorted) {
		for (var n in payload.spinePricelists) {
			if (pricelistsSorted[p].pricelist == payload.spinePricelists[n].pl_id) {
				payload.spinePricelists[n].used = 1;
				pricelistsMain.push(payload.spinePricelists[n]);
				pricelistAdded.push(payload.spinePricelists[n].pl_id);
			}
		}
	}
	for (var n in payload.spinePricelists) {
		if (pricelistAdded.indexOf(payload.spinePricelists[n].pl_id) === -1) {
			payload.spinePricelists[n].used = 0;
			pricelistsMain.push(payload.spinePricelists[n]);
		}
	}
	state.objUserPricelists = pricelistsMain;
}

export const fncSetPricelists = (state, payload) => {
	state.objUserPricelists = [];
}

export const fncResetPricelists = (state, payload) => {
	state.objUserPricelists.splice(payload.newIndex, 0, state.objUserPricelists.splice(payload.oldIndex, 1)[0]);
}

export const setObjUserStatus = (state, payload) => {
	for (var k in payload) {
		var excluded = 1;
		if (payload[k].excluded == 1) { excluded = 0;  }
		payload[k].excluded = excluded;
	}
	state.objUserStatus = payload;
}

export const setObjUserCompanies = (state, payload) => {
	var objCompanies = [];
	for (var k in payload) {
		payload[k].text = payload[k].name;
	}
	state.objUserCompanies = payload;
	for (var k in state.objUserCompanies) {
		if ( state.currentUserCompany == state.objUserCompanies[k].name ) {
			state.currentUserCompany = state.objUserCompanies[k].id;
		}
	}
}

export const fncEmptyUsers = (state, payload) => {
	if ( payload == '1' ) {
		state.repUsers = [];
	} else if (payload == '2' ) {
		state.customerUsers = [];
	} else if ( payload == '3' ) {
		state.specificUsers = [];
	} else if ( payload == '4' ) {
		state.publicUsers = [];
	}
}

export const setCurrentUserCompany = (state, payload) => {
	var companyName = payload.replace(/<(?:.|\n)*?>/gm, '');
	state.currentUserCompany = payload.replace(/<(?:.|\n)*?>/gm, '');
}

export const setCurrentCompany = (state, payload) => {
	state.currentCompany = payload;
}

export const setCurrentUser = (state, payload) => {
	var currentUser = [];
	var userRegions = [];
	var userPricelists = '';
	var setRegions = payload.regions.toString();
	var userCustomers = [];
	var userCompanies = [];
	var userReps = [];
	var objCompanies = payload.userData.company_name.split(',');
	for (var c in payload.userData.children) {
		if ( payload.userData.children[c].indexOf('|1|') > -1 ) {
			var objChildren = payload.userData.children[c].split("|1|");
			userReps.push({ name: objChildren[0] });
		} else if (payload.userData.children[c].indexOf('|2|') > -1 ) {
			var objChildren = payload.userData.children[c].split("|2|");
			userCustomers.push({ name: objChildren[1] + ' - ' + objChildren[0] });
		}
	}
	for (var c in objCompanies) {
		userCompanies.push({ name: objCompanies[c] });
    }
	for ( var k in payload.regionData ) {
		for (var c in payload.regionData.Country) {
			if (setRegions.indexOf(payload.regionData.Country[c].loc_id) > -1 && userRegions.indexOf(payload.regionData.Country[c].name) == -1) {
				userRegions.push(payload.regionData.Country[c].name);
			}
		}
		for (var c in payload.regionData.District) {
			if (setRegions.indexOf(payload.regionData.District[c].loc_id) > -1 && userRegions.indexOf(payload.regionData.District[c].name) == -1) {
				userRegions.push(payload.regionData.District[c].name);
			}
		}
		for (var c in payload.regionData.Province) {
			if (setRegions.indexOf(payload.regionData.Province[c].loc_id) > -1 && userRegions.indexOf(payload.regionData.Province[c].name) == -1 ) {
				userRegions.push(payload.regionData.Province[c].name);
			}
		}
		for (var c in payload.regionData.Town) {
			if (setRegions.indexOf(payload.regionData.Town[c].loc_id) > -1 && userRegions.indexOf(payload.regionData.Town[c].name) == -1) {
				userRegions.push(payload.regionData.Town[c].name);
			}
		}
		for (var c in payload.regionData.country) {
			if (setRegions.indexOf(payload.regionData.country[c].loc_id) > -1 && userRegions.indexOf(payload.regionData.country[c].name) == -1) {
				userRegions.push(payload.regionData.country[c].name);
			}
		}
	}
	var finalRegions = [];
	for ( var k in userRegions ) {
		finalRegions.push({name: userRegions[k]})
	}
	for ( var p in payload.userData.pricelist_links ) {
		for (var n in payload.pricelists) {
			if (payload.userData.pricelist_links[p] == payload.pricelists[n].pl_id) {
				userPricelists += payload.pricelists[n].pl_name + ', '
			}
		}
	}
	payload.userData['pricelists'] = userPricelists;
	currentUser.push(payload.userData);
	state.currentUser = currentUser;
	state.currentRegions = finalRegions;
	state.userCustomers = userCustomers;
	state.userCompanies = userCompanies;
	state.userReps = userReps;
}

export const setOverrideSettings = (state, payload) => {
	for ( var k in payload ) {
		payload[k].override = parseInt(payload[k].override);
	}
	state.overrideSettings = payload;
}

export const setUserLinks = (state, payload) => {
	var objLinks = []
	var linkedIds = [];
	for (var k in payload.l_users) {
		var link = { id: payload.l_users[k].id, fullname: payload.l_users[k].fullname, linked: 1, type: 'Company' };
		if (payload.l_users[k].company_name != undefined && payload.l_users[k].company_name != null && payload.l_users[k].company_name != '') {
            link.fullname = payload.l_users[k].company_name + ' - ' + payload.l_users[k].fullname;
            link.type = 'User';
		}
		if (link.fullname.trim() != '' && link.fullname.trim() != '-') {
			objLinks.push(link);
		}
		linkedIds.push(payload.l_users[k].id );
	}
	for (var k in payload.u_users) {
		if (linkedIds.indexOf(payload.u_users[k].id) == -1 ) {
			var link = { id: payload.u_users[k].id, fullname: payload.u_users[k].fullname, linked: 0, type: 'Company' };
			if (payload.u_users[k].company_name != undefined && payload.u_users[k].company_name != null && payload.u_users[k].company_name != '') {
                link.fullname = payload.u_users[k].company_name + ' - ' + payload.u_users[k].fullname;
                link.type = 'User';
			}
			if (link.fullname && link.fullname.trim() != '' && link.fullname.trim() != '-' ) {
				objLinks.push(link);
			}
		}

	}
	state.userLinks = objLinks;
}

export const fncEmptyUserLinks = (state, payload) => {
	state.userLinks = [];
}

export const fncSetUserRoles = (state, payload) => {
	for ( var p in payload ) {
		payload[p].name = payload[p].name + ' ( Level '+payload[p].level+' )';
	}
	state.userAddRoles = payload;
}

export const fncSetUserCompanies = (state, payload) => {
	state.userAddCompanies = payload;
}

export const fncSetObjUserEdit = (state, payload) => {

	payload.region_contact = payload.region_contact == 1 ? true : false;
	payload.active = payload.active == 1 ? true : false;
	payload.is_responsible_department_branch = payload.is_responsible_department_branch == 1 ? true : false;
	payload.type = parseInt(payload.type);
	if ( payload.vendor != null && payload.vendor != 'undefined' ) {

	  if( typeof(payload.vendor) == 'string' ) {
      var vendors = payload.vendor.split(',');
    } else {
      var vendors = payload.vendor;
    }

	  var arrVendors = [];

	  if( vendors.length > 0 ){
	    for( var v in vendors  ) {
        arrVendors.push( parseInt( vendors[v] ) );
      }
    }
		payload.vendor = arrVendors;
	}



  //payload.branch_id = payload.branch_id.split(',');
  payload.department = parseInt( payload.department );

	if( payload.branch_id != null && typeof(payload.branch_id) == 'string') {
		payload.branch_id = payload.branch_id.split(',');
		var intBranch = [];
		for( var b in payload.branch_id ) {
			intBranch.push(parseInt(payload.branch_id[b]))
		}
		payload.branch_id = intBranch;
	}

	/*if( payload.department != null && typeof(payload.department) == 'string') {
		payload.department = payload.department.split(',');
		var intDepartment = [];
		for( var d in payload.department ) {
			intDepartment.push(parseInt(payload.department[d]))
		}
		payload.department = intDepartment;
	}*/

	state.objUserEdit = payload;
}

export const fncSetObjCompanyEdit = (state, payload) => {
  if( payload.type != null && payload.type != undefined ) {
    payload.type = parseInt(payload.type);
  }
	state.objCompanyEdit = payload;
}

export const setUserRegions = (state, payload) => {
	var townAdded = [];
	var suburbAdded = [];
	var selectedRegions = [];
	if (state.objUserEdit.region != '' && state.objUserEdit.region != 'undefined' && state.objUserEdit.region != undefined  ) {
		selectedRegions = state.objUserEdit.region[0];
	} else if (state.objCompanyEdit != '') {
		selectedRegions = state.objCompanyEdit.region;
	}
	var objSelectedRegions = [];
	if (selectedRegions != '' ) {
		objSelectedRegions = selectedRegions.split(',');
    }
    // payload.Country = payload.Country.reverse();
	var userRegions = [];

	for (var k in payload.Country) {
		if (payload.Country[k].name != '') {
			payload.Country[k].children = [];
			if (selectedRegions != '') {
				if (objSelectedRegions.indexOf(String(payload.Country[k].id)) > -1) {
					userRegions.push({ display: true, id: payload.Country[k].id, name: payload.Country[k].name, parent: 0, loc_id: payload.Country[k].id, children: [], selected: true, oldSelected: true });
				} else {
					userRegions.push({ display: true, id: payload.Country[k].id, name: payload.Country[k].name, parent: 0, loc_id: payload.Country[k].id, children: [], selected: false, oldSelected: false });
				}
			} else {
				userRegions.push({ display: true, id: payload.Country[k].id, name: payload.Country[k].name, parent: 0, loc_id: payload.Country[k].id, children: [], selected: false });
			}
		}
	}

	if (payload.Province.length > 0) {
		for (var p in payload.Province) {
			for (var k in userRegions) {
				if (userRegions[k].id == payload.Province[p].parent) {
					if (payload.Town.length > 0) {
						if (selectedRegions != '') {
							if (objSelectedRegions.indexOf(String(payload.Province[p].loc_id)) > -1) {
								userRegions[k].children.push({ display: true, id: payload.Province[p].id, name: payload.Province[p].name, parent: payload.Province[p].parent, loc_id: payload.Province[p].loc_id, children: [], selected: true, oldSelected: true });
							} else {
								userRegions[k].children.push({ display: true, id: payload.Province[p].id, name: payload.Province[p].name, parent: payload.Province[p].parent, loc_id: payload.Province[p].loc_id, children: [], selected: false, oldSelected: false });
							}
						} else {
							userRegions[k].children.push({ display: true, id: payload.Province[p].id, name: payload.Province[p].name, parent: payload.Province[p].parent, loc_id: payload.Province[p].loc_id, children: [], selected: false });
						}
					} else {
						if (selectedRegions != '') {
							if (objSelectedRegions.indexOf(String(payload.Province[p].loc_id)) > -1) {
								userRegions[k].children.push({ display: true, id: payload.Province[p].id, name: payload.Province[p].name, parent: payload.Province[p].parent, loc_id: payload.Province[p].loc_id, selected: true, oldSelected: true });
							} else {
								userRegions[k].children.push({ display: true, id: payload.Province[p].id, name: payload.Province[p].name, parent: payload.Province[p].parent, loc_id: payload.Province[p].loc_id, selected: false, oldSelected: false });
							}
						} else {
							userRegions[k].children.push({ id: payload.Province[p].id, name: payload.Province[p].name, parent: payload.Province[p].parent, loc_id: payload.Province[p].loc_id, selected: false });
						}
					}
				}
			}
		}
		if (payload.Town.length > 0) {
			for (var u in userRegions) {
				for (var up in userRegions[u].children) {
					for (var t in payload.Town) {
						if (payload.Town[t].parent == userRegions[u].children[up].loc_id && townAdded.indexOf(String(payload.Town[t].loc_id)) < 0) {
							if (payload.Suburb != null && payload.Suburb.length > 0) {
								if (selectedRegions != '') {
									if (objSelectedRegions.indexOf(payload.Town[t].loc_id) > -1) {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, children: [], parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: true, oldSelected: true });
									} else {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, children: [], parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: false, oldSelected: false });
									}
								} else {
									userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, children: [], loc_id: payload.Town[t].loc_id, selected: false });
								}
							} else {
								if (selectedRegions != '') {
									if (objSelectedRegions.indexOf(String(payload.Town[t].loc_id)) > -1) {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: true, oldSelected: true });
									} else {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: false, oldSelected: false });
									}
								} else {
									userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: false });
								}
							}
							townAdded.push(payload.Town[t].loc_id);
						}
					}
				}
			}
		}
	}
	if (payload.Suburb != null && payload.Suburb.length > 0) {
		for (var u in userRegions) {
			for (var up in userRegions[u].children) {
				for (var p in userRegions[u].children[up].children) {
					for ( var s in payload.Suburb ) {
						if (payload.Suburb[s].parent == userRegions[u].children[up].children[p].loc_id && suburbAdded.indexOf(String(payload.Suburb[s].loc_id)) < 0) {


							if (selectedRegions != '') {
								if (objSelectedRegions.indexOf(String(payload.Suburb[s].loc_id)) > -1) {
									userRegions[u].children[up].children[p].children.push({ display: true, id: payload.Suburb[s].id, name: payload.Suburb[s].name, parent: payload.Suburb[s].parent, loc_id: payload.Suburb[s].loc_id, selected: true, oldSelected: true });
								} else {
									userRegions[u].children[up].children[p].children.push({ display: true, id: payload.Suburb[s].id, name: payload.Suburb[s].name, parent: payload.Suburb[s].parent, loc_id: payload.Suburb[s].loc_id, selected: false, oldSelected: false });
								}
							} else {
								userRegions[u].children[up].children[p].children.push({ display: true, id: payload.Suburb[s].id, name: payload.Suburb[s].name, parent: payload.Suburb[s].parent, loc_id: payload.Suburb[s].loc_id, selected: false });
							}
							suburbAdded.push(payload.Suburb[s].loc_id);
						}
					}
				}
			}
		}
	}
	if (payload.District.length > 0) {
		for (var d in payload.District) {
			for (var k in userRegions) {
				if (userRegions[k].id == payload.District[d].parent) {
					if (payload.Town.length > 0) {
						if (selectedRegions != '') {
							if (objSelectedRegions.indexOf(String(payload.District[d].loc_id)) > -1) {
								userRegions[k].children.push({ display: true, id: payload.District[d].id, name: payload.District[d].name, parent: payload.District[d].parent, loc_id: payload.District[d].loc_id, children: [], selected: true, oldSelected: true });
							} else {
								userRegions[k].children.push({ display: true, id: payload.District[d].id, name: payload.District[d].name, parent: payload.District[d].parent, loc_id: payload.District[d].loc_id, children: [], selected: false, oldSelected: false });
							}
						} else {
							userRegions[k].children.push({ display: true, id: payload.District[d].id, name: payload.District[d].name, parent: payload.District[d].parent, loc_id: payload.District[d].loc_id, children: [], selected: false });
						}
					} else {
						if (selectedRegions != '') {
							if (objSelectedRegions.indexOf(String(payload.District[d].loc_id)) > -1) {
								userRegions[k].children.push({ display: true, id: payload.District[d].id, name: payload.District[d].name, parent: payload.District[d].parent, loc_id: payload.District[d].loc_id, selected: true, oldSelected: true });
							} else {
								userRegions[k].children.push({ display: true, id: payload.District[d].id, name: payload.District[d].name, parent: payload.District[d].parent, loc_id: payload.District[d].loc_id, selected: false, oldSelected: false });
							}
						} else {
							userRegions[k].children.push({ display: true, id: payload.District[d].id, name: payload.District[d].name, parent: payload.District[d].parent, loc_id: payload.District[d].loc_id, selected: false });
						}
					}
				}
			}
		}
		if (payload.Town.length > 0) {
			for (var u in userRegions) {
				for (var up in userRegions[u].children) {
					for (var t in payload.Town) {
						if (payload.Town[t].parent == userRegions[u].children[up].loc_id && townAdded.indexOf(String(payload.Town[t].loc_id)) < 0) {
							if (payload.Suburb.length > 0) {
								if (selectedRegions != '') {
									if (objSelectedRegions.indexOf(String(payload.Town[t].loc_id)) > -1) {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, children: [], parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: true, oldSelected: true });
									} else {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, children: [], parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: false, oldSelected: false });
									}
								} else {
									userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, children: [], loc_id: payload.Town[t].loc_id, selected: false });
								}
							} else {
								if (selectedRegions != '') {
									if (objSelectedRegions.indexOf(String(payload.Town[t].loc_id)) > -1) {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: true, oldSelected: true });
									} else {
										userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: false, oldSelected: false });
									}
								} else {
									userRegions[u].children[up].children.push({ display: true, id: payload.Town[t].id, name: payload.Town[t].name, parent: payload.Town[t].parent, loc_id: payload.Town[t].loc_id, selected: false });
								}
							}
							townAdded.push(payload.Town[t].loc_id);
						}
					}
				}
			}
		}
		if (payload.Suburb.length > 0) {
			for (var u in userRegions) {
				for (var up in userRegions[u].children) {
					for (var p in userRegions[u].children[up].children) {
						for (var s in payload.Suburb) {
							if (payload.Suburb[s].parent == userRegions[u].children[up].children[p].loc_id && suburbAdded.indexOf(String(payload.Suburb[s].loc_id)) < 0) {
								if (selectedRegions != '') {
									if (objSelectedRegions.indexOf(String(payload.Suburb[s].loc_id)) > -1) {
										userRegions[u].children[up].children[p].children.push({ display: true, id: payload.Suburb[s].id, name: payload.Suburb[s].name, parent: payload.Suburb[s].parent, loc_id: payload.Suburb[s].loc_id, selected: true, oldSelected: true });
									} else {
										userRegions[u].children[up].children[p].children.push({ display: true, id: payload.Suburb[s].id, name: payload.Suburb[s].name, parent: payload.Suburb[s].parent, loc_id: payload.Suburb[s].loc_id, selected: false, oldSelected: false });
									}
								} else {
									userRegions[u].children[up].children[p].children.push({ display: true, id: payload.Suburb[s].id, name: payload.Suburb[s].name, parent: payload.Suburb[s].parent, loc_id: payload.Suburb[s].loc_id, selected: false });
								}
								suburbAdded.push(payload.Suburb[s].loc_id);
							}
						}
					}
				}
			}
		}
    }
	state.userRegions = [];
	state.userRegions = userRegions;
}

export const fncCheckRegionSetup = (state, payload) => {
	var checkSet = false;
	var parent = 0;
	for (var k in state.userRegions) {
		if ( state.userRegions[k].loc_id == payload.regionId ) {
			checkSet = true;
			for (var x in state.userRegions[k].children ) {
				state.userRegions[k].children[x].selected = payload.regionStatus;
				if (payload.regionStatus == false && payload.regionId == state.userRegions[k].children[x].parent ) {
					state.userRegions[k].children[x].selected = false;
				}
				parent = state.userRegions[k].parent;
				for (var y in state.userRegions[k].children[x].children ) {
					state.userRegions[k].children[x].children[y].selected = payload.regionStatus;
					if (payload.regionStatus == false && payload.regionId == state.userRegions[k].children[x].children[y].parent) {
						state.userRegions[k].children[x].children[y].selected = false;
					}
				}
			}
		}
		for (var c in state.userRegions[k].children ) {
			if (state.userRegions[k].children[c].loc_id == payload.regionId) {
				checkSet = true;
				for (var x in state.userRegions[k].children[c].children) {
					state.userRegions[k].children[c].children[x].selected = payload.regionStatus;
					if (payload.regionStatus == false && payload.regionId == state.userRegions[k].children[x].parent) {
						state.userRegions[k].children[x].selected = false;
					}
					parent = state.userRegions[k].children[c].parent;
				}
			}
		}
	}
	for (var k in state.userRegions) {
		if (state.userRegions[k].id == parent) {
			if ( payload.regionStatus == false ) {
				state.userRegions[k].selected = false;
			}
		}
	}

	console.log( payload );
	console.log( '-------' );
	console.log( state.userRegions );

}

export const fncHideRegionParent = (state, payload) => {
	for (var c in state.userRegions) {
		if (state.userRegions[c].loc_id == payload ) {
			state.userRegions[c].selected = false;
		}
		for (var p in state.userRegions[c].children ) {
			if (state.userRegions[c].children[p].loc_id == payload) {
				state.userRegions[c].children[p].selected = false;
			}
			for (var t in state.userRegions[c].children[p].children) {
				if (state.userRegions[c].children[p].children[t].loc_id == payload) {
					state.userRegions[c].children[p].children[t].selected = false;
				}
			}
		}
	}
}

export const fncCheckRegionSetupCompany = (state, payload) => {
	if ( payload.regionStatus == true ) {
		for (var c in state.userRegions) {
			if (state.userRegions[c].loc_id != payload.regionId) {
				state.userRegions[c].selected = false;
			}
			for (var p in state.userRegions[c].children) {
				if (state.userRegions[c].children[p].loc_id != payload.regionId) {
					state.userRegions[c].children[p].selected = false;
				}
				for (var t in state.userRegions[c].children[p].children) {
					if (state.userRegions[c].children[p].children[t].loc_id != payload.regionId) {
						state.userRegions[c].children[p].children[t].selected = false;
					}
				}
			}
		}
	}
}

export const fncFilterUsers = (state, payload) => {
	var filteredUsers = [];
	if (payload.uType == 'rep') {
		if (payload.search == '') {
			state.repUserSearch = state.repUsers;
		} else {
			var searchTerm = payload.search.toLowerCase();
			for (var a in state.repUsers) {
				var name = state.repUsers[a].name.toLowerCase();
				var surname = state.repUsers[a].surname.toLowerCase();
				var email = state.repUsers[a].email.toLowerCase();
				var fullname = (name + ' ' + surname).toLowerCase();
				var contactno = state.repUsers[a].contactno.toLowerCase();
				if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1 || contactno.indexOf(searchTerm) != -1) {
					filteredUsers.push(state.repUsers[a]);
				}
				for (var b in state.repUsers[a].branch) {
					var name = state.repUsers[a].branch[b].name.toLowerCase();
					var surname = state.repUsers[a].branch[b].surname.toLowerCase();
					var email = state.repUsers[a].branch[b].email.toLowerCase();
					var fullname = (name + ' ' + surname).toLowerCase();
          if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1) {
						filteredUsers.push(state.repUsers[a].branch[b]);
					}
					for (var c in state.repUsers[a].branch[b].branch) {
						var name = state.repUsers[a].branch[b].branch[c].name.toLowerCase();
						var surname = state.repUsers[a].branch[b].branch[c].surname.toLowerCase();
						var email = state.repUsers[a].branch[b].branch[c].email.toLowerCase();
						var fullname = (name + ' ' + surname).toLowerCase();
            if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1) {
							filteredUsers.push(state.repUsers[a].branch[b].branch[c]);
						}
						for (var d in state.repUsers[a].branch[b].branch[c].branch) {
							var name = state.repUsers[a].branch[b].branch[c].branch[d].name.toLowerCase();
							var surname = state.repUsers[a].branch[b].branch[c].branch[d].surname.toLowerCase();
							var email = state.repUsers[a].branch[b].branch[c].branch[d].email.toLowerCase();
							var fullname = (name + ' ' + surname).toLowerCase();
              if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1) {
								filteredUsers.push(state.repUsers[a].branch[b].branch[c].branch[d]);
							}
							for (var e in state.repUsers[a].branch[b].branch[c].branch[d].branch) {
								var name = state.repUsers[a].branch[b].branch[c].branch[d].branch[e].name.toLowerCase();
								var surname = state.repUsers[a].branch[b].branch[c].branch[d].branch[e].surname.toLowerCase();
								var email = state.repUsers[a].branch[b].branch[c].branch[d].branch[e].email.toLowerCase();
								var fullname = (name + ' ' + surname).toLowerCase();
                if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1) {
									filteredUsers.push(state.repUsers[a].branch[b].branch[c].branch[d].branch[e]);
								}
								for (var f in state.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch) {
									var name = state.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].name.toLowerCase();
									var surname = state.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].surname.toLowerCase();
									var email = state.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f].email.toLowerCase();
									var fullname = (name + ' ' + surname).toLowerCase();
                  if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1) {
										filteredUsers.push(state.repUsers[a].branch[b].branch[c].branch[d].branch[e].branch[f]);
									}
								}
							}
						}
					}
				}
			}

			var addedUsers = [];
			var finalFilteredUsers = [];

      for( var u in filteredUsers ) {
        if( addedUsers.includes(parseInt(filteredUsers[u].id)) == false ) {
          finalFilteredUsers.push( filteredUsers[u] );
          addedUsers.push(parseInt(filteredUsers[u].id));
        }
      }

			state.repUserSearch = finalFilteredUsers;
		}
	} else if (payload.uType == 'customer') {
		if (payload.search == '') {
			state.customerUserSearch = state.customerUsers;
		} else {
			var searchTerm = payload.search.toLowerCase();
			for (var a in state.customerUsers) {
				var name = state.customerUsers[a].name.toString().toLowerCase();
				var companyMatched = name.indexOf(searchTerm) != -1;
				var matchedUsers = [];
				for (var b in state.customerUsers[a].branch) {
					var name = state.customerUsers[a].branch[b].name.toLowerCase();
					var surname = state.customerUsers[a].branch[b].surname.toLowerCase();
					var fullname = (name + ' ' + surname).toString().toLowerCase();
					if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1) {
						matchedUsers.push(state.customerUsers[a].branch[b]);
					}
				}
				if (companyMatched) {
					var matchedCompany = {};
					for (var key in state.customerUsers[a]) {
						if (state.customerUsers[a].hasOwnProperty(key)) {
							matchedCompany[key] = state.customerUsers[a][key];
						}
					}
					matchedCompany._searchExpanded = matchedUsers.length > 0;
					filteredUsers.push(matchedCompany);
				} else {
					for (var u in matchedUsers) {
						filteredUsers.push(matchedUsers[u]);
					}
				}
			}
			state.customerUserSearch = filteredUsers;
		}
	} else if (payload.uType == 'specifier') {
		if (payload.search == '') {
			state.specificUserSearch = state.specificUsers;
		} else {
			var searchTerm = payload.search.toLowerCase();
			for (var a in state.specificUsers) {
				var name = state.specificUsers[a].name.toLowerCase();
				var companyMatched = name.indexOf(searchTerm) != -1;
				if (companyMatched) {
					filteredUsers.push(state.specificUsers[a]);
				}
				if (companyMatched == false) {
					for (var b in state.specificUsers[a].branch) {
						var name = state.specificUsers[a].branch[b].name.toLowerCase();
						var surname = state.specificUsers[a].branch[b].surname.toLowerCase();
						var fullname = (name + ' ' + surname).toLowerCase();
						if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1) {
							filteredUsers.push(state.specificUsers[a].branch[b]);
						}
					}
				}
			}
			state.specificUserSearch = filteredUsers;
		}
	} else if (payload.uType == 'public') {
		if (payload.search == '') {
			state.publicUserSearch = state.specificUsers;
		} else {
			var searchTerm = payload.search.toLowerCase();
			for (var a in state.publicUsers) {
				var name = state.publicUsers[a].name.toLowerCase();
				var surname = state.publicUsers[a].surname.toLowerCase();
				var email = state.publicUsers[a].email.toLowerCase();
				var fullname = (name + ' ' + surname).toLowerCase();
				if (name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1) {
					filteredUsers.push(state.publicUsers[a]);
				}
			}
			state.publicUserSearch = filteredUsers;
		}
	} else if (payload.uType == 'vendor') {
		if (payload.search == '') {
			state.vendorUserSearch = state.vendorUsers;
		} else {
			var searchTerm = payload.search.toLowerCase();
			for (var a in state.vendorUsers) {
				var name = state.vendorUsers[a].name.toLowerCase();
				var surname = state.vendorUsers[a].surname.toLowerCase();
				var email = state.vendorUsers[a].email.toLowerCase();
				var vendorName = state.vendorUsers[a].vendorName != null ? state.vendorUsers[a].vendorName.toLowerCase() : '_|_';
				var fullname = (name + ' ' + surname).toLowerCase();
				if (vendorName.indexOf(searchTerm) != -1 || name.indexOf(searchTerm) != -1 || surname.indexOf(searchTerm) != -1 || fullname.indexOf(searchTerm) != -1 || email.indexOf(searchTerm) != -1) {
					filteredUsers.push(state.vendorUsers[a]);
				}
			}
			state.vendorUserSearch = filteredUsers;
		}
	}
}

export const setUserVendors = (state, payload) => {
	var vendors = [];
	for ( var v in payload ) {
		vendors.push({id: payload[v].id, text: payload[v].name});
	}
	state.userVendors = vendors;
}

export const fncSetRepsLoaded = (state, payload) => {
	state.repsLoaded = payload;
}

export const fncSetCustomersLoaded = (state, payload) => {
	state.customersLoaded = payload;
}

export const fncSetPublicLoaded = (state, payload) => {
	state.publicLoaded = payload;
}

export const fncSetSpecifierLoaded = (state, payload) => {
	state.specifierLoaded = payload;
}

export const fncSetVendorLoaded = (state, payload) => {
	state.vendorLoaded = payload;
}

export const fncFilterTreeByBranches = (state, payload) => {
	var branchUsers = [];
	for( var u in state.repUsers ) {
		if( state.repUsers[u].branch_id != null && state.repUsers[u].branch_id.indexOf(payload) != -1 ) {
			// level 2
			for( var a in state.repUsers[u].branch ) {
				var aBranches = [];
				if( state.repUsers[u].branch[a].branch_id != null && state.repUsers[u].branch[a].branch_id.indexOf(payload) != -1 ) {
					aBranches.push(state.repUsers[u].branch[a]);
				}
				if( aBranches.length == 0 ) {
					state.repUsers[u].branch = [];
				} else {
					state.repUsers[u].branch = aBranches;
				}
				// level 3
				for( var b in state.repUsers[u].branch[a].branch ) {
					var bBranches = [];
					if( state.repUsers[u].branch[a].branch[b].branch_id != null && state.repUsers[u].branch[a].branch[b].branch_id.indexOf(payload) != -1 ) {
						bBranches.push(state.repUsers[u].branch[a].branch[b]);
					}
					if( bBranches.length == 0 ) {
						state.repUsers[u].branch[a].branch = [];
					} else {
						state.repUsers[u].branch[a].branch = bBranches;
					}
				}
			}
			branchUsers.push( state.repUsers[u] );
		}
	}
	state.repUsers = branchUsers;
}

export const fncFilterTreeByDepartments = (state, payload) => {

}

export const fncSetUserLoading = (state, payload) => {
  state.userLoading = payload;
}

export const fncLeadUserSelected = (state, payload) => {
  state.leadUserSelected = payload;
}

export const fncNewLeadUsers = (state, payload) => {
  state.newLeadUsers = payload;
}

export const fncSetQuoteNo = (state, payload) => {
  state.quoteNo = payload;
}

export const fncSetPublicUserTotalPages = (state, payload) => {
  state.publicTotatlPages = payload;
}

export const fncSetUserAvatar = (state, payload) => {
  state.userAvatar = payload;  
}

export const fncSetRepsShortList = (state, payload) => {
  state.repsShortList = payload;  
}
